import React, { useState, useRef, useEffect } from 'react';
import client from '../api/client';

export default function TwoFactorVerifyPage({ tempToken, onSuccess, onBack }) {
  const [code, setCode]       = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) { setError('認証コードを入力してください'); return; }
    setLoading(true); setError('');
    try {
      await client.post('/auth/2fa/verify', {
        temp_token: tempToken,
        code: code.replace(/\s/g, ''),
      });
      // 認証 token は HttpOnly Cookie でサーバーがセット済み
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.detail ?? '認証に失敗しました');
      setCode('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={wrapStyle}>
      <div style={cardStyle}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 44, lineHeight: 1, marginBottom: 10 }}>🔐</div>
          <div style={titleStyle}>2段階認証</div>
          <div style={subStyle}>
            認証アプリ（Google Authenticator など）の6桁のコードを入力してください
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <input
            ref={inputRef}
            className="form-input"
            type="text"
            inputMode="numeric"
            maxLength={6}
            placeholder="123456"
            value={code}
            onChange={e => setCode(e.target.value.replace(/\D/g, ''))}
            style={{
              textAlign: 'center', fontSize: 28, fontWeight: 700,
              letterSpacing: '0.3em', padding: '14px',
            }}
          />

          {error && <div className="msg msg-error">{error}</div>}

          <button type="submit" className="btn btn-primary" disabled={loading}
            style={{ width: '100%', padding: '12px' }}>
            {loading ? <><span className="spinner" />確認中…</> : '確認'}
          </button>

          <div style={{ textAlign: 'center', fontSize: 12, color: '#aaa' }}>
            バックアップコードの場合はそのまま入力してください（例：ABCD1234-EFGH5678）
          </div>

          <button type="button" onClick={onBack}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#9B5FE3', fontSize: 13, textDecoration: 'underline',
            }}>
            ← ログイン画面に戻る
          </button>
        </form>
      </div>
    </div>
  );
}

const wrapStyle = {
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #FF6B9D 0%, #9B5FE3 60%, #7048D4 100%)',
  padding: '16px',
};
const cardStyle = {
  background: '#fff', borderRadius: 24,
  padding: 'clamp(24px, 7vw, 44px) clamp(20px, 6vw, 40px)',
  width: '100%', maxWidth: 400,
  boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
};
const titleStyle = {
  fontFamily: "'Nunito', 'M PLUS Rounded 1c', sans-serif",
  fontSize: 22, fontWeight: 900, color: '#7048D4',
};
const subStyle = { fontSize: 13, color: '#888', marginTop: 8, lineHeight: 1.6 };
